import { Fragment } from "react";
import { useContainer } from "unstated-next";
import { GlobalStateContainer } from "../../../provider/GlobalStateContainer";

const ranges = [1, 3, 5, 10];

const CircleWithLabel = ({ range, currentRange, onClick }) => (
  <div onClick={() => onClick(range)} className="relative">
    <div className={`w-[10px] h-[10px] rounded-full border-2 border-slate-300 ${currentRange === range ? 'bg-slate-300' : 'bg-transparent'}`}></div>
    <div className="text-xs absolute top-[15px] left-1/2 transform -translate-x-1/2">{range}km</div>
  </div>
);

const MapRangeStepper = () => {
  const { searchLocationRangeInKm, setSearchLocationRangeInKm } = useContainer(GlobalStateContainer);
  return (
    <div className="absolute bottom-[50px] left-1/2 transform -translate-x-1/2">
      <div className="flex justify-center items-center">
        <div className="flex justify-center items-center bg-white h-14 rounded-md gap-2.5 shadow-md px-5 pb-4">
          <div className="flex items-center cursor-pointer">
            {/* First line */}
            <div className="w-[30px] h-[3px] rounded bg-slate-300"></div>

            {ranges.map((range, index) => (
              <Fragment key={range}>
                <CircleWithLabel
                  range={range}
                  currentRange={searchLocationRangeInKm}
                  onClick={setSearchLocationRangeInKm}
                />
                {/* Line between circles */}
                {index < ranges.length - 1 && (
                  <div className="w-[60px] h-[3px] rounded bg-slate-300"></div>
                )}
              </Fragment>
            ))}

            {/* Last line */}
            <div className="w-[30px] h-[3px] rounded bg-slate-300"></div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default MapRangeStepper;